/**
 * Placeholder Sprint A4 S4 (Google Calendar sync — agendamentos + disponibilidade).
 * Quando S4 entregar, este arquivo vira a tab funcional.
 */
export function CalendarTab(): JSX.Element {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-12 text-center">
      <span className="text-4xl">📅</span>
      <h2 className="text-lg font-semibold text-text-primary">Calendário</h2>
      <p className="max-w-md text-sm text-text-secondary">
        Próxima sprint (S4) entregará integração com Google Calendar para sincronizar agendamentos e
        disponibilidade.
      </p>
      <span className="rounded bg-bg-muted px-3 py-1 text-xs">Em breve · sub-projeto S4</span>
    </div>
  );
}
